import TableHead from '@mui/material/TableHead';

export { TableHead };
